import { ErrorHandler, Provider } from '@angular/core';
import { AppErrorHandler } from './app-error.handler';
import { environment } from '@lentau/core/environments';

export const ErrorHandlerConfig: ReadonlyArray<Provider> = environment.isEnableSentry
  ? [
      {
        provide: ErrorHandler,
        useExisting: AppErrorHandler,
      },
    ]
  : [];
